import React from 'react'
import HeroSection from './components/HeroSection'
import QuickActionsBar from './components/QuickActionsBar'
import HoneyRecipesSection from './components/HoneyRecipeSection'
import KnowledgeHub from './components/KnowledgeHub'
import Newsletter from './components/Newsletter'
import Footer from './components/Footer'
import BestSelling from './components/BestSelling'

export default function HomePage() {
  return (
    <div>
        

       {/* <Header/> */}
       <HeroSection/>
       <QuickActionsBar/>
       <BestSelling/>
       <HoneyRecipesSection/>
       <KnowledgeHub/>
       <Newsletter/>
       {/* <Footer/> */}

    </div>
  )
}
